<template>
  <!-- Master dropdown because it was always such a headache to set up dropdowns and
  manage their context stack and getting the z-index right given our heavy use of 
  box shadows, opacity and other context stack affecting properties.  -->
  <Transition name="dropdown">
    <div class="ELYXDropdown" :style="getDropdownPosition">
      <SidebarElementDropdownContents v-if="activeDropdown.name === 'SidebarElementDropdownButton'" />
    </div>
  </Transition>
</template>

<script>
import { ELYXCentralStore } from "../ELYX/ELYXStore";
import SidebarElementDropdownContents from "../ELYX/SidebarElements/SidebarElementDropdownContents.vue";

export default {
  components: {
    SidebarElementDropdownContents,
  },
  computed: {
    activeDropdown: () => ELYXCentralStore.state.activeDropdown,
    getDropdownPosition() {
      return `top: ${this.activeDropdown.top}; left: ${this.activeDropdown.left}`;
    },
  },
};
</script>

<style>
.ELYXDropdown {
  position: absolute;
  left: var(--dropdown-position-left);
  top: var(--dropdown-position-top);
  z-index: 10;
  border-radius: 1.2rem;
  width: 215px;
  height: 130px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 0.8);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 6px;
}
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.3s ease;
}
.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
}
</style>
